import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NovaCirurgiaForm from "../../components/CadastroCirurgia/NovaCirurgiaForm.tsx";
import Button from "../../ui/Button.tsx";
import "../../styles/design-system.css";

// NovaCirurgiaForm não tem botão de submit dentro dele por design — o form
// tem id="nova-cirurgia-form" e espera um <button type="submit" form="...">
// externo (é assim que o Drawer em listagemCirurgia.tsx usa). Essa página
// standalone não tinha esse botão, então não dava pra agendar por aqui.
const CadastroCirurgiaPage: React.FC = () => {
  const navigate = useNavigate();
  const [enviando, setEnviando] = useState(false);

  return (
    <div className="ds">
      <div className="ds-page-head">
        <div>
          <h1>Nova cirurgia</h1>
          <p>Preencha os dados do procedimento — campos com * são obrigatórios.</p>
        </div>
      </div>
      <div className="ds-card" style={{ padding: 24, maxWidth: 760 }}>
        <NovaCirurgiaForm
          onSuccess={() => navigate("/cirurgias")}
          onSubmittingChange={setEnviando}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--border)" }}>
          <Button variant="outline" onClick={() => navigate("/cirurgias")} disabled={enviando}>
            Cancelar
          </Button>
          <Button type="submit" form="nova-cirurgia-form" variant="primary" disabled={enviando}>
            {enviando ? "Agendando..." : "Agendar cirurgia"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CadastroCirurgiaPage;
